import {
  CONTRACT_COMPLIANCE__INTERVAL_BOTH_TIMES,
  CONTRACT_COMPLIANCE__INVALID_TIME,
  CONTRACT_COMPLIANCE__START_EQUALS_END,
  CONTRACT_COMPLIANCE__TIME_REQUIRED,
} from 'translations/constants';
import { IIntervalPayload } from 'types/contract-compliance/IContractCompliance';

const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export type IntervalDraft = { start: string; end: string };

export type IntervalErrors = Partial<Record<keyof IntervalDraft, string>>;

export const EMPTY_INTERVAL: IntervalDraft = { start: '', end: '' };

export const toIntervalDraft = (startTime: string | null, endTime: string | null): IntervalDraft => ({
  start: startTime ?? '',
  end: endTime ?? '',
});

const isEmptyInterval = (draft: IntervalDraft): boolean => draft.start.trim() === '' && draft.end.trim() === '';

export const validateInterval = (draft: IntervalDraft, required: boolean): IntervalErrors => {
  if (!required && isEmptyInterval(draft)) return {};
  const emptyKey = required ? CONTRACT_COMPLIANCE__TIME_REQUIRED : CONTRACT_COMPLIANCE__INTERVAL_BOTH_TIMES;
  const errors: IntervalErrors = {};
  (['start', 'end'] as const).forEach(field => {
    const value = draft[field].trim();
    if (value === '') errors[field] = emptyKey;
    else if (!TIME_PATTERN.test(value)) errors[field] = CONTRACT_COMPLIANCE__INVALID_TIME;
  });
  if (!errors.start && !errors.end && draft.start.trim() === draft.end.trim()) {
    errors.end = CONTRACT_COMPLIANCE__START_EQUALS_END;
  }
  return errors;
};

export const toIntervalPayload = (draft: IntervalDraft): IIntervalPayload =>
  isEmptyInterval(draft)
    ? { startTime: null, endTime: null }
    : { startTime: draft.start.trim(), endTime: draft.end.trim() };

export const formatInterval = (startTime: string, endTime: string): string => `${startTime}–${endTime}`;
